export type TrackingLinkModel = {
  id?: number,
  cache_key?: number,
  key?: string,
  owner_id?: number,
  owner_type?: string,
  recipient_id?: number,
  recipient_type?: string,
  subject_id?: number,
  subject_type?: string,
  title?: string,
  token?: string,
  url?: string,
}

export type TrackingLinkRequestOptions = {
  include_tracking_link_recipient?: boolean,
  include_tracking_link_shortened_url?: boolean,
  include_tracking_link_subject?: boolean,
  include_tracking_link_total_views?: boolean,
}

const state = {
  id: undefined,
  owner_id: undefined,
  owner_type: '',
  recipient_id: undefined,
  recipient_type: '',
  subject_id: undefined,
  subject_type: '',
  title: '',
  url: '',
}

export const requiredFields = [
  { key: 'owner_id' },
  { key: 'owner_type' },
  { key: 'recipient_id' },
  { key: 'recipient_type' },
  { key: 'subject_id' },
  { key: 'subject_type' },
  { key: 'title' },
  { key: 'url' },
]

export default state
